import { AdditionalServiceType } from '../util/AdditionalServiceType'

export enum ServiceType {
    TEMPLATE_CONFIGURATION = AdditionalServiceType.TEMPLATE_CONFIGURATION,
    REALTY_CONFIGURATION = AdditionalServiceType.REALTY_CONFIGURATION,
    AMO_CONFIGURATION = AdditionalServiceType.AMO_CONFIGURATION,
    BITRIX_CONFIGURATION = AdditionalServiceType.BITRIX_CONFIGURATION,
    LEGAL_CHECKS = AdditionalServiceType.LEGAL_CHECKS,
    AI_TEMPLATE_CONFIGURATION = AdditionalServiceType.AI_TEMPLATE_CONFIGURATION,
    PASSPORT_VERIFICATION = 'passport_verification',
    PHONE_VERIFICATION = 'phone_verification',
    SELFIE_VERIFICATION = 'selfie_verification',
    SIGNING_SMS = 'signing_sms',
    SIGNING_WHATSAPP = 'signing_whatsapp',
    CONTRACT_LINK_SMS = 'contract_link_sms',
    UPGRADE = 'upgrade'
}

export const SERVICE_DISPLAY_NAMES: Record<ServiceType, string> = {
    [ServiceType.TEMPLATE_CONFIGURATION]: 'Настройка шаблона',
    [ServiceType.REALTY_CONFIGURATION]: 'Настройка интеграции с RealtyCalendar',
    [ServiceType.AMO_CONFIGURATION]: 'Настройка интеграции с amoCRM',
    [ServiceType.BITRIX_CONFIGURATION]: 'Настройка интеграции с Bitrix24',
    [ServiceType.LEGAL_CHECKS]: 'Пакет юридических проверок',
    [ServiceType.AI_TEMPLATE_CONFIGURATION]: 'Настройка шаблона ИИ',
    [ServiceType.PASSPORT_VERIFICATION]: 'Проверка паспорта',
    [ServiceType.PHONE_VERIFICATION]: 'Проверка телефона',
    [ServiceType.SELFIE_VERIFICATION]: 'Проверка селфи с паспортом',
    [ServiceType.SIGNING_SMS]: 'Отправка SMS при подписании',
    [ServiceType.SIGNING_WHATSAPP]: 'Отправка WhatsApp при подписании',
    [ServiceType.CONTRACT_LINK_SMS]: 'SMS со ссылкой на документ',
    [ServiceType.UPGRADE]: 'Дополнительная услуга'
}

export function getServiceDisplayName(type: string): string {
    return SERVICE_DISPLAY_NAMES[type as ServiceType] || type
}
